module.exports = __webpack_public_path__ + "static/media/womanUser.3ea05818.png";